<template>
  <div class="row">
    <div class="col">
      <div class="card bg-white">
        <div class="card-header bg-gray-100">
          <p class="text-semibold no-margin">
            Lote de Distribuição
          </p>
          <div class="heading-elements">
            <i class="fas fa-long-arrow-alt-left position-left" @click="voltar()" style="cursor: pointer"></i>
          </div>
        </div>

        <div class="box-body">
					<div v-show="errorMessage != ''" class="alert alert-danger">{{ errorMessage }}</div>

          <div class="row">
            <div class="form-group col-12 col-md-6">
              <label for="cd_ponto_apoio" style="float: left">Destino: &nbsp;&nbsp;&nbsp;</label>
              <select id="cd_ponto_apoio" v-model="registro.cd_ponto_apoio" style="width: auto" class="form-control" v-bind:class="{ 'box-input-required': errors.cd_ponto_apoio }">
                <option value="" selected>Selecione</option>
                <option v-for="item in pontos_apoio" v-bind:value="item.cd_ponto_apoio">{{ item.cd_ponto_apoio + ' - ' + item.descricao }}</option>
              </select>
              <span v-show="errors.cd_ponto_apoio != null" class="help-inline">{{ errors.cd_ponto_apoio }}</span>
            </div>
          </div>

          <br/>

          <div class="box box-primary">
            <div class="box-header">
              <div class="col-6 col-md-6 col-sm-8 col-xs-8">
                <i class="fas fa-clipboard"></i>
                <h3 class="box-title">Equipamentos</h3>
              </div>

              <div class="col-6 col-md-6 col-sm-4 col-xs-4 div-btn-novo">
                <button id="newButton" class="btn btn-sm btn-primary btn-novo" @click="adicionarEquipamento()" style="width: 33px" data-tooltip="Novo"><i class="fa fa-plus" aria-hidden="true"></i></button>
              </div>
            </div>

            <div class="box-body">
              <div class="row" v-show="registro.lote_equipamentos.length > 0" style="border-bottom: 1px solid #e9e9e9; margin: 0;">
                <div class="form-group col-5 col-md-5 col-sm-5 col-xs-5"><b>Código Equipamento</b></div>
                <div class="form-group col-5 col-md-5 col-sm-5 col-xs-5"><b>Código Player</b></div>
                <div class="form-group col-2 col-md-2 col-sm-2 col-xs-2"></div>
              </div>
              <div class="row" v-for="item in registro.lote_equipamentos" v-bind:key="item.cd_equipamento" style="border-bottom: 1px solid #e9e9e9; margin: 0; padding: 6px;">
                <div class="form-group col-5 col-md-5 col-sm-5 col-xs-5" style="margin-bottom: 0">{{ item.cd_equipamento }}</div>
                <div class="form-group col-5 col-md-5 col-sm-5 col-xs-5" style="margin-bottom: 0">{{ item.cd_player }}</div>
                <div class="form-group col-2 col-md-2 col-sm-2 col-xs-2" style="margin-bottom: 0">
                  <a @click="removerEquipamento(item.cd_equipamento)" class="btn btn-sm btn-danger legitRipple" data-tooltip="Remover" data-delay="500" data-hasqtip="0" aria-describedby="qtip-0"><span class="glyphicon glyphicon-minus"></span></a>
                </div>
              </div>
              <span v-show="errors.lote_equipamentos != null" class="help-inline">{{ errors.lote_equipamentos }}</span>
            </div>
          </div>
        </div>

        <div class="box-footer text-center">
          <div class="btn-group">
            <button type="button" id="cancelButton" class="btn btn-warning" @click="voltar()">Cancelar</button>
            <button type="button" id="gravarButton" class="btn btn-success" @click="gravar()">Gravar</button>
          </div>
        </div>
      </div>
    </div>

    <modal name="modal-equipamento" :adaptive="true" width="600" height="500">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" @click="$modal.hide('modal-equipamento')"><span aria-hidden="true">×</span></button>
          <h3 class="modal-title">{{ titleModal }}</h3>
        </div>
        <div class="modal-body">
					  <div v-show="errorMessageModal != ''" class="alert alert-danger">{{ errorMessageModal }}</div>

            <label for="equipamento_sel">Equipamento <sup class="text-danger">* </sup></label>
            
            <multiselect value="cd_equipamento" placeholder="Selecione os equipamentos" :max-height="250" :multiple="true" :close-on-select="false" track-by="cd_player" label="cd_player" v-model="equipamentosSelecionados" :options="equipamentos_disponiveis">
            </multiselect>
            <span v-show="errorsModal.equipamento_sel != null" class="help-inline">{{ errorsModal.equipamento_sel }}</span>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-default pull-left" @click="$modal.hide('modal-equipamento')">Cancelar</button>
          <button type="button" class="btn btn-primary" @click="adicionarEquipamentoConfirma()">Confirmar</button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
/* eslint-disable */
import DistribuicaoLoteActions from '../../actions/DistribuicaoLoteActions'
import PontoApoioActions from '../../actions/PontoApoioActions'
import EquipamentoActions from '../../actions/EquipamentoActions'
import Multiselect from 'vue-multiselect'
export default {
  name: 'novo',
  components: { Multiselect },
  data () {
    return {
      equipamentosSelecionados: null,
      titleModal: '',
      errorMessageModal: '',
      errorsModal: {},
      errorMessage: '',
      errors: {},
      hasError: false,
      registro: {
        cd_ponto_apoio: '',
        lote_equipamentos: []
      },
      pontos_apoio: [],
      equipamentos_disponiveis: [],
      equipamento_sel: ''
    }
  },
  mounted () {
    this.$parent.$parent.$data.description = 'Novo'

    this.listarPontoApoioAtivos()
    this.listarEquipamentosDisponiveis()
  },
  methods: {
    voltar () {
      this.$router.push((this.$route.query.ret_url ? this.$route.query.ret_url : '/distribuicao-equipamentos'))
    },
    listarPontoApoioAtivos () {
      PontoApoioActions.listarPontoApoioAtivos()
        .then(res => {
          this.pontos_apoio = res
        })
    },
    listarEquipamentosDisponiveis () {
      EquipamentoActions.listarEquipamentosDisponiveis()
        .then(res => {
          this.equipamentos_disponiveis = res
        })
    },
    validation () {
      this.errors = {}
      this.hasError = false

      if (!this.registro.cd_ponto_apoio) {
        this.errors.cd_ponto_apoio = 'Este campo deve ser preenchido.'
        this.hasError = true
      }

      if (this.registro.lote_equipamentos.length === 0) {
        this.errors.lote_equipamentos = 'Insira pelo menos um equipamento.'
        this.hasError = true
      }
    },
    gravar () {
      this.validation()

      if (!this.hasError) {
        this.$parent.$parent.$data.showModalLoader = true

        let equipamentos = []
        this.registro.lote_equipamentos.forEach((item) => { equipamentos.push(item.cd_equipamento) })

        DistribuicaoLoteActions.cadastrar({
          cd_ponto_apoio: this.registro.cd_ponto_apoio,
          equipamentos: equipamentos
        })
        .then(response => {
          this.$parent.$parent.$data.showModalLoader = false
          this.$router.push((this.$route.query.ret_url ? this.$route.query.ret_url : '/distribuicao-equipamentos'))
        })
        .catch((error) => {
          console.log(error.message)
          this.errorMessage = 'Ocorreu um erro ao gravar o registro.'
          this.$parent.$parent.$data.showModalLoader = false
        })
      }
    },
    adicionarEquipamento () {
      this.titleModal = 'Adicionar Equipamneto'
      this.errorMessageModal = ''
      this.errorsModal = {}

      this.$modal.show('modal-equipamento')
    },
    adicionarEquipamentoConfirma () {
      this.equipamentosSelecionados.forEach(element => {
        let selecionado = this.equipamentos_disponiveis.filter((item) => { return item.cd_equipamento === element.cd_equipamento })

        this.registro.lote_equipamentos.push(selecionado[0])
        this.equipamentos_disponiveis = this.equipamentos_disponiveis.filter((item) => { return item.cd_equipamento !== element.cd_equipamento })

        delete this.errors.lote_equipamentos

      });

      this.$modal.hide('modal-equipamento')
    },
    removerEquipamento (id) {
      let selecionado = this.registro.lote_equipamentos.filter((item) => { return item.cd_equipamento === id })

      this.equipamentos_disponiveis.push(selecionado[0])
      this.registro.lote_equipamentos = this.registro.lote_equipamentos.filter((item) => { return item.cd_equipamento !== id })
    }
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>


// WEBPACK FOOTER //
// src/pages/distribuicao-equipamentos/Novo.vue